import type { FC } from 'react'
import { BrandLogo, cn } from '@yanolja-rnd/nol-design-system'

export interface FooterProps {
  className?: HTMLDetailsElement['className']
}

export const Footer: FC<FooterProps> = ({ className = '' }) => {
  return (
    <footer
      className={cn(
        'flex w-full bg-fill-neutral-weak px-16 pb-200 pt-16 pc:px-0 pc:pb-96',
        className
      )}
    >
      <div className="flex flex-col gap-12 pc:w-pc-size">
        {/*로고*/}
        <div className="py-16">
          <BrandLogo theme="gray_medium" className="h-18 w-49" />
        </div>

        {/*푸터 메시지*/}
        <div className="text-text-neutral-sub typography-caption-11-regular-multiline">
          (주)놀유니버스는 통신판매 중개자로서 통신판매의 당사자가 아니며 상품의 예약, 이용 및 환불
          등과 관련한 의무와 책임은 각 판매자에게 있습니다.
        </div>
      </div>
    </footer>
  )
}
